<label *ngIf="title" class="radio-group-title">{{title}}
  <i *ngIf="description" class="icon-information-16"
     [appTooltip]="description"
     [tooltipTheme]="'white'"
     [tooltipMaxWidth]="318"
     [tooltipPosition]="'bottomLeft'"></i>
  </label>
<div class="container {{displayStyle}}">
  <ng-content></ng-content>
</div>

